import {ref} from 'vue';

export default {
    install: (app, options) => {

        const companyTypes = ref([]);
        const companyStatuses = ref([]);
        const companyRegions = ref([]);
        const companyCountries = ref([]);
        const companyDistributors = ref([]);
        const companyPlans = ref([]);

        const loadCompaniesParameters = (url = '/companies/parameters') => {
            window.lazy_axios.get(url)
                .then((response) => {

                    if (response.data.regions) {
                        companyRegions.value = response.data.regions;
                    }

                    if (response.data.countries) {
                        companyCountries.value = response.data.countries;
                    }

                    if (response.data.types) {
                        companyTypes.value = response.data.types;
                    }

                    if (response.data.distributors) {
                        companyDistributors.value = response.data.distributors;
                    }

                    if (response.data.plans) {
                        companyPlans.value = response.data.plans;
                    }

                    if (response.data.statuses) {
                        companyStatuses.value = response.data.statuses;
                    }
                });
        };

        app.provide('companyTypes', companyTypes);
        app.provide('companyStatuses', companyStatuses);
        app.provide('companyRegions', companyRegions);
        app.provide('companyCountries', companyCountries);
        app.provide('companyDistributors', companyDistributors);
        app.provide('companyPlans', companyPlans);
        app.provide('loadCompaniesParameters', loadCompaniesParameters);
    },
}
